import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex",
  style: {"height":"100%","justify-content":"start","align-items":"baseline"}
}
const _hoisted_2 = {
  class: "px-3",
  style: {"align-self":"center"}
}
const _hoisted_3 = { class: "caption my-0 line-clamp" }
const _hoisted_4 = {
  key: 0,
  class: "my-0 text--dark"
}
const _hoisted_5 = {
  key: 1,
  class: "my-0 text--dark"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: { width: '12px', height: '100%', background: 'transparent' } }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    class: "my-pointer ion-activatable w100 flex-column pa-1",
    style: _normalizeStyle({
      height: _ctx.height,
      'justify-content': 'flex-end',
      'border-left': '6px solid rgb(' + _ctx.color + ')',
    })
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.label), 1),
          (_ctx.trends && _ctx.trends.length > 1)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(_ctx.changeInTrend > 0 ? ("-") : _ctx.changeInTrend == 0 ? "±" :  ("+")) + _toDisplayString(_ctx.absChangeInTrend) + "% ", 1))
            : _createCommentVNode("", true),
          (_ctx.trends && _ctx.trends.length == 1)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.trends[0]) + "% ", 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_6,
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trends, (a, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'aple-' + index,
            style: _normalizeStyle({
          width: _ctx.trends.length == 1 ? '20%' : '5%',
          'min-width': '12px',
          'max-width': '48px',
          height: a + '%',
          'background-image':
            'linear-gradient(rgb(' + _ctx.color + '), rgba(' + _ctx.color + ', 0.3)',
          margin: '0px 8px',
          'border-top-left-radius': '2px',
          'border-top-right-radius': '2px',
        })
          }, null, 4))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}